import { LinkExternal01Icon } from '@langchain/untitled-ui-icons';
import Link from '@mui/joy/Link';

import { Link as RouterLink } from 'react-router-dom';

import { useOrganizationId } from '@/hooks/useSwr';
import { ExampleSchema, RunSchema } from '@/types/schema';
import { getDatasetPath } from '@/utils';
import { appExamplePath } from '@/utils/constants';

export function ReferenceExampleCell({
  example,
}: {
  row: RunSchema;
  example?: ExampleSchema;
}) {
  const organizationId = useOrganizationId();
  return example && organizationId ? (
    <Link
      fontSize="inherit"
      component={RouterLink}
      startDecorator={
        <LinkExternal01Icon className="size-4" fontSize="inherit" />
      }
      to={`${getDatasetPath(
        example?.dataset_id,
        organizationId
      )}/${appExamplePath}/${example.id}`}
      onClick={(e) => e.stopPropagation()}
      sx={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      {example.name}
    </Link>
  ) : null;
}
